module.exports = __webpack_public_path__ + "img/product_13.2ce4083.webp";